export default __webpack_public_path__ + "static/media/ag-title-en.8309fbfe.webp";